import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { isEmpty } from 'lodash';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';
import { BackCallPopup, Icon } from '@fttb/common/components';
import { getCaptchaFlag, selectCommonData } from '@fttb/common/store';
import { callbackRequestDataShape } from '@fttb/common/types';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// fixme
import { getActionBar } from "../../store/actionBarWithBackCall/selectors";
import { isPageTypeFmc } from "../../store/blocks/selectors";
import { onFloatingPhoneClickAnalytics } from "../../store/FloatingPhone/actions";
import { getIsFloatingPhoneWidgetOpen } from "../../store/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var FloatingPhoneWidget = /*#__PURE__*/memo(function (_ref) {
  var callbackRequestData = _ref.callbackRequestData,
    isOpen = _ref.isOpen,
    showCaptcha = _ref.showCaptcha,
    onClick = _ref.onClick,
    isConvergent = _ref.isConvergent;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: cx('phone-widget'),
    onClick: onClick,
    type: "button",
    "data-t-id": "components-FloatingPhoneWidget"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cx({
      'phone-widget--mobile': isMobile
    }),
    name: "phoneFilled"
  })), isOpen && /*#__PURE__*/React.createElement(BackCallPopup, {
    data: callbackRequestData,
    isConvergent: isConvergent,
    isIcon: true,
    isOpen: true,
    onClose: onClick,
    redesign: true,
    showCaptcha: showCaptcha
  }));
});
FloatingPhoneWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  showCaptcha: PropTypes.bool,
  isConvergent: PropTypes.bool,
  callbackRequestData: PropTypes.shape(callbackRequestDataShape)
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isOpen: getIsFloatingPhoneWidgetOpen(state),
    callbackRequestData: selectCommonData(state),
    showCaptcha: getCaptchaFlag(state),
    isConvergent: isPageTypeFmc(state),
    shouldRender: isEmpty(getActionBar(state))
  };
};
var mapDispatchToProps = {
  onClick: onFloatingPhoneClickAnalytics
};
var FloatingPhoneWidgetWithStore = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(FloatingPhoneWidget);
export { FloatingPhoneWidgetWithStore as FTTBFloatingPhoneWidget };